import React from 'react'
import spendingAlertSuccess from "../../../../../assets/images/spending-alert-success.png"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useDispatch, useSelector } from 'react-redux'
import logFirebaseEvents from '../../../../LogFirebaseEvents';
import { appTheme } from '../../../../../helpers/utils/Utils';
import SavingGoalIcon from '../../../../../assets/kudzu-plus-images/savingGoalIcon.png'



const ExistedSavingGoalAlertModal = ({ onCanelTranfer, modalClose ,onBack}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);

    const handleBackToSavingGoals = () => {
        dispatch({ type: 'ERROR_MODAL_SAVING_GOAL', payload: { errorModalvalueSavingGoal: false } });
        modalClose(false)
        onBack('SavingGoalFields')
    }

    return (
        <div className='flex flex-col justify-center items-center w-full'>
            <p className='font-hanken-grotesk lg:text-[19px] md:text-[17px] sm:text-[14px] text-[16px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] 
             md:leading-[28px] text-[var(--heading-in-modal-is-clr)] '>{t("already_exists_name")}</p>
            <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />

            <div className='flex flex-col justify-center items-center w-full'>

            <div className=' flex flex-col gap-4 justify-center items-center w-full'>
                <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={handleBackToSavingGoals} onKeyDown={(e) => { if (e.key === "Enter") handleBackToSavingGoals() }}>{t("try_again")}</button>
                <button className='focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#262B3A] text-[#FEFAEE] cursor-pointer border-2 px-2 py-4 border-[#4B70B9] w-full' onClick={()=>{navigate("/Toolkit/ToolkitMenu")}}>{t("back_to_climb")}</button>
            </div>
            </div>

        </div>
    )
}

export default withOidcSecure(ExistedSavingGoalAlertModal)